/**
 *  @class
 *  @function BackToTop
 *
 *  Regra OBRAH (19/jul): a seta é TRANSIENTE — aparece ao rolar e,
 *  parado alguns segundos, recolhe sozinha (gaveta descendo, translateY do CSS).
 *  Nunca fica estacionada por cima de outros controles (seta com seta, nunca).
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
		constructor() {
			super();
			this.pageHeight = window.innerHeight;
			this.idleTimer = null;
			this.IDLE_MS = 2500;
		}

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			this.addEventListener('touchstart', this.onClick, {
				passive: true
			});
			// pairando sobre a seta ela não recolhe debaixo do cursor
			this.addEventListener('mouseenter', () => clearTimeout(this.idleTimer));
			this.addEventListener('mouseleave', () => this.armIdle());
			window.addEventListener('scroll', this.checkVisible.bind(this));
		}

		armIdle() {
			clearTimeout(this.idleTimer);
			this.idleTimer = setTimeout(() => {
				this.classList.remove('back-to-top--active');
			}, this.IDLE_MS);
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
				if (y > this.pageHeight) {
					this.classList.add('back-to-top--active');
					this.armIdle();
				} else {
					clearTimeout(this.idleTimer);
					this.classList.remove('back-to-top--active');
				}
			});
		}

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});
		}
	}
	customElements.define('back-to-top', BackToTop);
}
